

export default function Loading() {

  return (
   <div className='loader-container'>
   <div className='spinner'></div>
   </div>
  )
}

